import http from "../http-common";

class NotificationService {
  get(params = {}) {
    return http.get("/notification/", { params });
  }

  markRead(id) {
    return http.put(`/notification/${id}/read`);
  }

  markAllRead() {
    return http.put("/notification/read-all");
  }
}

export default new NotificationService();
